import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AdminToolsPageForm from "./AdminToolsPageForm";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "50px", // space for fixed footer
  },
}));

function AdminToolsPage(props) {
  useEffect(() => {}, []);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AdminToolsPageForm />
    </div>
  );
}

export default AdminToolsPage;
